import { BpSubpage } from 'components/BpSubpage/BpSubpage';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useParams } from 'react-router-dom';
import { CourseSubmissionTeacherContent } from './TeacherContent/CourseSubmissionTeacherContent';

export const CourseSubmissionSubpage = () => {
  const { pimAuthClaims } = useAuthClaims();
  const { courseUuid, submissionUuid } = useParams<{
    courseUuid: string;
    submissionUuid: string;
  }>();

  const permissions = usePermissionChecker();

  return (
    <BpSubpage
      isForbidden={
        !permissions?.canCreateAssignment({
          uuid: courseUuid ?? '',
          organization: { uuid: pimAuthClaims.getOrganizationUuid() },
        })
      }
    >
      <CourseSubmissionTeacherContent submissionUuid={submissionUuid ?? ''} />
    </BpSubpage>
  );
};
